import React from 'react';
import { InputNumber } from 'antd';
import { formatWarrantyNumber, parseWarrantyNumber } from './warrantyNumber';

export default function WarrantyNumberInput({ precision = 0, ...props }) {
  return <InputNumber decimalSeparator=',' precision={precision} max={Number.MAX_SAFE_INTEGER} {...props}
    formatter={(value, info) => info?.userTyping ? info.input : formatWarrantyNumber(value, precision)}
    parser={value => parseWarrantyNumber(value) ?? ''} />;
}
